import { cache, CACHE_KEYS } from 'tradera-utils/cache';

export default () => {
    const recent = cache.read(CACHE_KEYS.RECENTLY_VIEWED_ITEMS) || [];
    return {
        cache: {},
        recent
    };
};
